import { createFeatureSelector, createSelector } from '@ngrx/store'
import { PROFILES_FEATURE_KEY, ProfileState, profilesAdapter } from './profiles.reducer'

// Lookup the 'Profiles' feature state managed by NgRx
export const getProfilesState = createFeatureSelector<ProfileState>(PROFILES_FEATURE_KEY)

const { selectAll, selectEntities } = profilesAdapter.getSelectors()

export const getProfilesLoaded = createSelector(getProfilesState, (state: ProfileState) => state.loaded)

export const getAllProfiles = createSelector(getProfilesState, (state: ProfileState) => selectAll(state))

export const getProfilesEntities = createSelector(getProfilesState, (state: ProfileState) => selectEntities(state))

export const getProfilesCount = createSelector(getProfilesState, (state: ProfileState) => state.count)
